(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;

  if (!clamp || !parseNumber) {
    return;
  }

  var LZ_URI_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$';
  var LZ_BASE_REVERSE_DIC = {};

  function toFixedTrim(value, decimals) {
    var text = Number(value).toFixed(decimals);
    return text.replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
  }

  function hashString(input) {
    var hash = 2166136261;
    for (var i = 0; i < input.length; i += 1) {
      hash ^= input.charCodeAt(i);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return hash >>> 0;
  }

  function nextRand(seedObj) {
    seedObj.value = (1664525 * seedObj.value + 1013904223) >>> 0;
    return seedObj.value / 4294967296;
  }

  function deepClone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function stripMediaFromStateSnapshot(state) {
    if (!state || typeof state !== 'object') {
      return state;
    }
    if (state.background && typeof state.background === 'object') {
      if (typeof state.background.imageDataUrl === 'string' && /^data:/i.test(state.background.imageDataUrl)) {
        state.background.imageDataUrl = '';
      }
    }
    if (Array.isArray(state.overlayItems)) {
      for (var i = 0; i < state.overlayItems.length; i += 1) {
        var item = state.overlayItems[i];
        if (item && (item.type === 'image' || item.type === 'logo')) {
          if (typeof item.srcDataUrl === 'string' && /^data:/i.test(item.srcDataUrl)) {
            item.srcDataUrl = '';
          }
        }
      }
    }
    return state;
  }

  function stripComputedFieldsFromStateSnapshot(state) {
    if (!state || typeof state !== 'object') {
      return state;
    }
    if (Array.isArray(state.references)) {
      for (var r = 0; r < state.references.length; r += 1) {
        var ref = state.references[r];
        if (!ref || typeof ref !== 'object') {
          continue;
        }
        Object.keys(ref).forEach(function (key) {
          if (key.indexOf('_computed') === 0) {
            delete ref[key];
          }
        });
      }
    }
    if (Array.isArray(state.overlayItems)) {
      for (var i = 0; i < state.overlayItems.length; i += 1) {
        var item = state.overlayItems[i];
        if (!item || typeof item !== 'object') {
          continue;
        }
        Object.keys(item).forEach(function (key) {
          if (key.indexOf('_computed') === 0) {
            delete item[key];
          }
        });
      }
    }
    return state;
  }

  function encodeBase64Url(text) {
    return btoa(unescape(encodeURIComponent(text))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }

  function decodeBase64Url(text) {
    var base64 = text.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
      base64 += '=';
    }
    return decodeURIComponent(escape(atob(base64)));
  }

  function parseJsonObject(rawText) {
    if (typeof rawText !== 'string' || !rawText.trim()) {
      return null;
    }
    try {
      var parsed = JSON.parse(rawText);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function roundNumberToDecimals(value, decimals) {
    if (!Number.isFinite(value)) {
      return value;
    }
    var factor = Math.pow(10, decimals);
    var rounded = Math.round(value * factor) / factor;
    return Object.is(rounded, -0) ? 0 : rounded;
  }

  function roundNumbersDeep(value, decimals) {
    if (Array.isArray(value)) {
      return value.map(function (entry) {
        return roundNumbersDeep(entry, decimals);
      });
    }
    if (value && typeof value === 'object') {
      var out = {};
      Object.keys(value).forEach(function (key) {
        out[key] = roundNumbersDeep(value[key], decimals);
      });
      return out;
    }
    if (typeof value === 'number') {
      return roundNumberToDecimals(value, decimals);
    }
    return value;
  }

  function mapObjectKeysDeep(value, keyMap) {
    if (Array.isArray(value)) {
      return value.map(function (entry) {
        return mapObjectKeysDeep(entry, keyMap);
      });
    }
    if (value && typeof value === 'object') {
      var out = {};
      Object.keys(value).forEach(function (key) {
        var mappedKey = Object.prototype.hasOwnProperty.call(keyMap, key) ? keyMap[key] : key;
        out[mappedKey] = mapObjectKeysDeep(value[key], keyMap);
      });
      return out;
    }
    return value;
  }

  function getLzBaseValue(alphabet, character) {
    if (!LZ_BASE_REVERSE_DIC[alphabet]) {
      LZ_BASE_REVERSE_DIC[alphabet] = {};
      for (var i = 0; i < alphabet.length; i += 1) {
        LZ_BASE_REVERSE_DIC[alphabet][alphabet.charAt(i)] = i;
      }
    }
    return LZ_BASE_REVERSE_DIC[alphabet][character];
  }

  function lzCompressToUriSafe(input) {
    if (input == null) {
      return '';
    }
    return lzCompress(String(input), 6, function (a) {
      return LZ_URI_ALPHABET.charAt(a);
    });
  }

  function lzDecompressFromUriSafe(input) {
    if (input == null) {
      return '';
    }
    if (input === '') {
      return null;
    }
    var source = String(input).replace(/ /g, '+');
    return lzDecompress(source.length, 32, function (index) {
      return getLzBaseValue(LZ_URI_ALPHABET, source.charAt(index));
    });
  }

  function lzCompress(uncompressed, bitsPerChar, getCharFromInt) {
    if (uncompressed == null) {
      return '';
    }
    var i;
    var contextDictionary = {};
    var contextDictionaryToCreate = {};
    var contextC = '';
    var contextWC = '';
    var contextW = '';
    var contextEnlargeIn = 2;
    var contextDictSize = 3;
    var contextNumBits = 2;
    var contextData = [];
    var contextDataVal = 0;
    var contextDataPosition = 0;

    var writeBit = function (bitValue) {
      contextDataVal = (contextDataVal << 1) | bitValue;
      if (contextDataPosition === bitsPerChar - 1) {
        contextDataPosition = 0;
        contextData.push(getCharFromInt(contextDataVal));
        contextDataVal = 0;
      } else {
        contextDataPosition += 1;
      }
    };

    var writeBits = function (numBits, bitsValue) {
      for (var b = 0; b < numBits; b += 1) {
        writeBit(bitsValue & 1);
        bitsValue >>= 1;
      }
    };

    var writeContextW = function () {
      if (Object.prototype.hasOwnProperty.call(contextDictionaryToCreate, contextW)) {
        if (contextW.charCodeAt(0) < 256) {
          writeBits(contextNumBits, 0);
          writeBits(8, contextW.charCodeAt(0));
        } else {
          writeBits(contextNumBits, 1);
          writeBits(16, contextW.charCodeAt(0));
        }
        contextEnlargeIn -= 1;
        if (contextEnlargeIn === 0) {
          contextEnlargeIn = Math.pow(2, contextNumBits);
          contextNumBits += 1;
        }
        delete contextDictionaryToCreate[contextW];
      } else {
        writeBits(contextNumBits, contextDictionary[contextW]);
      }

      contextEnlargeIn -= 1;
      if (contextEnlargeIn === 0) {
        contextEnlargeIn = Math.pow(2, contextNumBits);
        contextNumBits += 1;
      }
    };

    for (i = 0; i < uncompressed.length; i += 1) {
      contextC = uncompressed.charAt(i);
      if (!Object.prototype.hasOwnProperty.call(contextDictionary, contextC)) {
        contextDictionary[contextC] = contextDictSize;
        contextDictSize += 1;
        contextDictionaryToCreate[contextC] = true;
      }

      contextWC = contextW + contextC;
      if (Object.prototype.hasOwnProperty.call(contextDictionary, contextWC)) {
        contextW = contextWC;
      } else {
        writeContextW();
        contextDictionary[contextWC] = contextDictSize;
        contextDictSize += 1;
        contextW = String(contextC);
      }
    }

    if (contextW !== '') {
      writeContextW();
    }

    writeBits(contextNumBits, 2);
    while (true) {
      contextDataVal <<= 1;
      if (contextDataPosition === bitsPerChar - 1) {
        contextData.push(getCharFromInt(contextDataVal));
        break;
      }
      contextDataPosition += 1;
    }
    return contextData.join('');
  }

  function lzDecompress(length, resetValue, getNextValue) {
    var dictionary = [];
    var next;
    var enlargeIn = 4;
    var dictSize = 4;
    var numBits = 3;
    var entry = '';
    var result = [];
    var i;
    var bits;
    var resb;
    var maxpower;
    var power;
    var c;
    var data = { val: getNextValue(0), position: resetValue, index: 1 };

    for (i = 0; i < 3; i += 1) {
      dictionary[i] = i;
    }

    bits = 0;
    maxpower = Math.pow(2, 2);
    power = 1;
    while (power !== maxpower) {
      resb = data.val & data.position;
      data.position >>= 1;
      if (data.position === 0) {
        data.position = resetValue;
        data.val = getNextValue(data.index++);
      }
      bits |= (resb > 0 ? 1 : 0) * power;
      power <<= 1;
    }

    switch (next = bits) {
      case 0:
        bits = 0;
        maxpower = Math.pow(2, 8);
        power = 1;
        while (power !== maxpower) {
          resb = data.val & data.position;
          data.position >>= 1;
          if (data.position === 0) {
            data.position = resetValue;
            data.val = getNextValue(data.index++);
          }
          bits |= (resb > 0 ? 1 : 0) * power;
          power <<= 1;
        }
        c = String.fromCharCode(bits);
        break;
      case 1:
        bits = 0;
        maxpower = Math.pow(2, 16);
        power = 1;
        while (power !== maxpower) {
          resb = data.val & data.position;
          data.position >>= 1;
          if (data.position === 0) {
            data.position = resetValue;
            data.val = getNextValue(data.index++);
          }
          bits |= (resb > 0 ? 1 : 0) * power;
          power <<= 1;
        }
        c = String.fromCharCode(bits);
        break;
      case 2:
        return '';
      default:
        return null;
    }

    dictionary[3] = c;
    var w = c;
    result.push(c);

    while (true) {
      if (data.index > length) {
        return '';
      }

      bits = 0;
      maxpower = Math.pow(2, numBits);
      power = 1;
      while (power !== maxpower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position === 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index++);
        }
        bits |= (resb > 0 ? 1 : 0) * power;
        power <<= 1;
      }

      switch (c = bits) {
        case 0:
          bits = 0;
          maxpower = Math.pow(2, 8);
          power = 1;
          while (power !== maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position === 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb > 0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize] = String.fromCharCode(bits);
          c = dictSize;
          dictSize += 1;
          enlargeIn -= 1;
          break;
        case 1:
          bits = 0;
          maxpower = Math.pow(2, 16);
          power = 1;
          while (power !== maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position === 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb > 0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize] = String.fromCharCode(bits);
          c = dictSize;
          dictSize += 1;
          enlargeIn -= 1;
          break;
        case 2:
          return result.join('');
        default:
          break;
      }

      if (enlargeIn === 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits += 1;
      }

      if (dictionary[c]) {
        entry = dictionary[c];
      } else if (c === dictSize) {
        entry = w + w.charAt(0);
      } else {
        return null;
      }
      result.push(entry);

      dictionary[dictSize] = w + entry.charAt(0);
      dictSize += 1;
      enlargeIn -= 1;

      w = entry;

      if (enlargeIn === 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits += 1;
      }
    }
  }

  function isTransparentColorValue(value) {
    if (!value || typeof value !== 'string') {
      return true;
    }
    var text = value.trim().toLowerCase();
    if (!text || text === 'transparent') {
      return true;
    }
    var rgbaMatch = text.match(/^rgba\(\s*\d+,\s*\d+,\s*\d+,\s*([0-9.]+)\s*\)$/);
    if (rgbaMatch) {
      return parseFloat(rgbaMatch[1]) <= 0;
    }
    return false;
  }

  function parseCssColor(value) {
    if (!value || typeof value !== 'string') {
      return null;
    }
    var text = value.trim().toLowerCase();
    var hexMatch = text.match(/^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/);
    if (hexMatch) {
      var hex = hexMatch[1];
      if (hex.length === 3 || hex.length === 4) {
        var rShort = parseInt(hex.charAt(0) + hex.charAt(0), 16);
        var gShort = parseInt(hex.charAt(1) + hex.charAt(1), 16);
        var bShort = parseInt(hex.charAt(2) + hex.charAt(2), 16);
        var aShort = hex.length === 4 ? parseInt(hex.charAt(3) + hex.charAt(3), 16) / 255 : 1;
        return { r: rShort, g: gShort, b: bShort, a: clamp(aShort, 0, 1) };
      }
      var rLong = parseInt(hex.slice(0, 2), 16);
      var gLong = parseInt(hex.slice(2, 4), 16);
      var bLong = parseInt(hex.slice(4, 6), 16);
      var aLong = hex.length === 8 ? parseInt(hex.slice(6, 8), 16) / 255 : 1;
      return { r: rLong, g: gLong, b: bLong, a: clamp(aLong, 0, 1) };
    }
    var rgbMatch = text.match(/^rgba?\(\s*([0-9.]+)\s*,\s*([0-9.]+)\s*,\s*([0-9.]+)(?:\s*,\s*([0-9.]+)\s*)?\)$/);
    if (rgbMatch) {
      return {
        r: clamp(Math.round(parseFloat(rgbMatch[1])), 0, 255),
        g: clamp(Math.round(parseFloat(rgbMatch[2])), 0, 255),
        b: clamp(Math.round(parseFloat(rgbMatch[3])), 0, 255),
        a: clamp(parseNumber(rgbMatch[4], 1), 0, 1)
      };
    }
    return null;
  }

  function parseOpaqueCssColor(value) {
    var parsed = parseCssColor(value);
    if (!parsed) {
      return null;
    }
    if (parseNumber(parsed.a, 1) <= 0.01) {
      return null;
    }
    return parsed;
  }

  function mixColors(base, target, factor) {
    if (!base) {
      return target || null;
    }
    if (!target) {
      return base;
    }
    var t = clamp(parseNumber(factor, 0), 0, 1);
    return {
      r: Math.round(base.r + (target.r - base.r) * t),
      g: Math.round(base.g + (target.g - base.g) * t),
      b: Math.round(base.b + (target.b - base.b) * t),
      a: clamp(parseNumber(base.a, 1), 0, 1)
    };
  }

  function colorToCss(color, alphaOverride) {
    if (!color) {
      return '';
    }
    var alpha = Number.isFinite(alphaOverride) ? clamp(alphaOverride, 0, 1) : clamp(parseNumber(color.a, 1), 0, 1);
    if (alpha >= 0.999) {
      return 'rgb(' + color.r + ', ' + color.g + ', ' + color.b + ')';
    }
    return 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + toFixedTrim(alpha, 3) + ')';
  }

  sbbNamespace.toFixedTrim = toFixedTrim;
  sbbNamespace.hashString = hashString;
  sbbNamespace.nextRand = nextRand;
  sbbNamespace.deepClone = deepClone;
  sbbNamespace.stripMediaFromStateSnapshot = stripMediaFromStateSnapshot;
  sbbNamespace.stripComputedFieldsFromStateSnapshot = stripComputedFieldsFromStateSnapshot;
  sbbNamespace.encodeBase64Url = encodeBase64Url;
  sbbNamespace.decodeBase64Url = decodeBase64Url;
  sbbNamespace.parseJsonObject = parseJsonObject;
  sbbNamespace.roundNumbersDeep = roundNumbersDeep;
  sbbNamespace.mapObjectKeysDeep = mapObjectKeysDeep;
  sbbNamespace.lzCompressToUriSafe = lzCompressToUriSafe;
  sbbNamespace.lzDecompressFromUriSafe = lzDecompressFromUriSafe;
  sbbNamespace.parseCssColor = parseCssColor;
  sbbNamespace.parseOpaqueCssColor = parseOpaqueCssColor;
  sbbNamespace.mixColors = mixColors;
  sbbNamespace.colorToCss = colorToCss;
  sbbNamespace.isTransparentColorValue = isTransparentColorValue;
})();
